import config from "../config";
import { createContext } from "react";
import { ApiService } from "../services/ApiService";

export const ServiceContext = createContext(null);

export const ServiceProvider = ({ children }) => {
  const services = {
    infrastructureService: new ApiService(config.servicesHosts.infrastructureService),
    authenticationService: new ApiService(config.servicesHosts.authenticationService),
    dataService: new ApiService(config.servicesHosts.dataService),
    notificationService: new ApiService(config.servicesHosts.notificationService),
    
    infrastructureHealthCheckService: new ApiService(config.servicesHosts.infrastructureService.replace("/api/v1", "")),
    dataHealthCheckService: new ApiService(config.servicesHosts.dataService.replace("/api/v1", "")),
    notificationHealthCheckService: new ApiService(config.servicesHosts.notificationService.replace("/api/v1", "")),
  };

  return (
    <ServiceContext.Provider value={services}>
      {children}
    </ServiceContext.Provider>
  );
};